import cmp from './Activation'

export default cmp
